module.exports = __webpack_public_path__ + "media/audio1.f65af8c6.mp3";